export class UrlModal {
  // static _URL = "http://localhost:3005";
  static _URL = "https://api.doqmatokens.com";
  // static _URL = 'http://192.168.1.12:3006';
}